"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Option = function Option() {
  return null;
};
var _default = exports.default = Option;